import { reduxKey } from './constants';
import { getCurrentModal } from '../../Modals/redux/selectors';
import { ModalType } from '../../Modals/redux/types';
function getStateSlice(state) {
    return state[reduxKey] || {};
}
export function isAwardModalOpen(state) {
    var _a;
    return ((_a = getCurrentModal(state)) === null || _a === void 0 ? void 0 : _a.type) === ModalType.AWARD_BADGE;
}
export function getAwardModalBadges(state, userId) {
    var _a;
    var awardableBadges = (_a = getStateSlice(state).awardableBadges) === null || _a === void 0 ? void 0 : _a[userId];
    if (!awardableBadges) {
        return [];
    }
    return awardableBadges.results;
}
export function getIsAwarding(state) {
    return getStateSlice(state).isAwarding;
}
//# sourceMappingURL=selectors.js.map